import { IRole } from '../redux/slices/rolesSlice'

export const getRoleAuthId = (roles: IRole[], role: string): string => {
    return roles.find((i) => i.roleName === role)?.roleAuthId || ''
}
